const useRadioButtonList = () => {
  const isDisabled = false;

  return {isDisabled}
};

export default useRadioButtonList;